import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { ExploreForm } from "./ExploreForm";
// import {
// useDispatch,
// useSelector,
// } from "react-redux";
import HealthCareFacilities from "../../../../components/HealthCareFacilities";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLocation, useHistory } from "react-router-dom";
import "./exploreCard.scss";
import { getSession } from "../../../redux/actions/authActions";
import PaymentSuccessModal from "../../../Modals/PaymentSuccessModal";
import PaymentFailedModal from "../../../Modals/PaymentFailedModal";

// import { exploreFacility } from "../../../redux/actions/dbactions/exploreActions";

const ExploreLayout = ({ cartItems, handleCartItems }) => {
  const location = useLocation();
  const history = useHistory();
  const { role_id, user_profile_id } = getSession();
  // const dispatch = useDispatch();

  // const { exploreList } = useSelector((state) => state.exploreReducer);
  // const exploreService = exploreList?.svc_typ_desc;
  // const explorelist = exploreList.usr?.rec || [];
  const queryParams = new URLSearchParams(location.search);
  let { payment_status } = queryParams;
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailedModal, setShowFailedModal] = useState(false);

  const svc_type_id = queryParams.get("svc_type_id");
  const iso_city_id = queryParams.get("iso_city_id");
  const iso_cntry_id = queryParams.get("iso_cntry_id");
  const svc_provider_name = queryParams.get("svc_provider_name");
  const payload = {};
  if (svc_provider_name) {
    payload.svc_provider_name = svc_provider_name;
  }
  if (iso_cntry_id) {
    payload.iso_cntry_id = iso_cntry_id;
  }
  if (iso_city_id) {
    payload.iso_city_id = iso_city_id;
  }
  if (svc_type_id) {
    payload.svc_type_id = svc_type_id;
  }

  const handleSubmit = (values) => {
    // dispatch(exploreFacility(values));
    const queryString = new URLSearchParams(values).toString();
    history.push(`/dashboard?${queryString}`);
  };

  useEffect(() => {
    if (payment_status === "success") {
      setShowSuccessModal(true);
    } else if (payment_status === "failed") {
      setShowFailedModal(true);
    }
  }, [payment_status]);

  return (
    <div>
      {Object.keys(payload).length > 0 ? (
        <>
          <Header
            pageTitle={`Explore > Facilities`}
            icon={<Icon icon="material-symbols:explore-outline" />}
          />
          <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
            <h5 className="text-base sm:text-[26px] w-full whitespace-wrap">
              Exploring facilities
            </h5>
          </div>
          <HealthCareFacilities
            isLogged={true}
            page={"/dashboard"}
            cartItems={cartItems}
            handleCartItems={handleCartItems}
            roleId={role_id}
            userProfileId={user_profile_id}
          />
        </>
      ) : (
        <ExploreForm handleSubmit={handleSubmit} />
      )}
      <PaymentSuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
      />
      <PaymentFailedModal
        show={showFailedModal}
        setShowFailedModal={setShowFailedModal}
        onHide={() => setShowFailedModal(false)}
      />
    </div>
  );
};
export default withRouter(ExploreLayout);
